import api from '../api'

export default {

  suppliers: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/suppliers?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },


  create: async supplier => {
    return api.post('api/suppliers', supplier)
  },

  get: async id => {
    return api.get('api/suppliers/' + id)
  },

  update: async (id,supplier) => {
    return api.put('api/suppliers/' + id, supplier)
  },

  delete: async id => {
    return api.delete('api/suppliers/' + id)
  }
}
